import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';
import { confirmPasswordReset } from '../../services/authService';
import { setAuthToken } from '../../services/apiClient';
import './ResetPasswordPage.css';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/password-reset');
    }
  }, [token, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage('パスワードが一致しません。');
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const res = await confirmPasswordReset({
        token,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      // 自動ログイン：受け取ったaccess/refreshを保存
      const { access, refresh } = res.data;
      localStorage.setItem('auth_token', access);
      localStorage.setItem('refresh_token', refresh);
      setAuthToken(access);
      navigate('/dashboard');
    } catch (err: any) {
      setMessage(err.response?.data?.detail || '更新に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-page">
      <h1>新しいパスワードを設定</h1>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification error">{message}</div>}
      <form onSubmit={handleSubmit}>
        <label>パスワード</label>
        <input
          type="password"
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="新しいパスワード"
        />
        <label>パスワード（確認）</label>
        <input
          type="password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="パスワードを再入力"
        />
        <Button type="submit" disabled={loading}>
          {loading ? '処理中...' : 'パスワードを更新'}
        </Button>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
